import React from 'react'
import classNames from 'classnames'
import { Tag as AntTag } from 'antd'
import { default as CheckableTag } from './CheckableTag'
import './Tag.scss'

const Tag = ({ className, v2, ...restProps }) => {
  const props = {
    ...restProps,
    className: classNames(className, 'pan-tag', v2 ? 'pan-tag-border-radius' : '')
  }

  return (
    <AntTag {...props} />
  )
}

Tag.CheckableTag = CheckableTag
Tag.AntTag = AntTag
export default Tag
